import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import {
  DEFAULT_PROXIMITY_BG_OPACITY, DEFAULT_PROXIMITY_BORDER_OPACITY,
} from '~/proximity/panel/form/proximityPanelForm.container';
import { shapeDrawStateSelector } from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.selectors';
import { ShapeDrawConfiguration } from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.state';
import { proximityToolSelector } from '~/store/frontendState/proximityTool/proximityTool.selectors';

const DEFAULT_CIRCLE_PARAMETERS = {
  borderColor: '000',
  borderOpacity: 1,
  borderWidth: 2,
  fillColor: '000',
  fillOpacity: 0.35,
  units: 'pixels' as const,
};

export const shapeDrawProximityCircleParamsSelector = createStateSelector([proximityToolSelector],
  ({ proximityColor, borderColor, borderLineWidth }) => ({
    ...DEFAULT_CIRCLE_PARAMETERS,

    borderColor: borderColor.hex,
    borderOpacity: DEFAULT_PROXIMITY_BORDER_OPACITY * 100,
    borderWidth: borderLineWidth,
    fillColor: proximityColor.hex,
    fillOpacity: DEFAULT_PROXIMITY_BG_OPACITY * 100,
    withCenterMarker: true,
    units: 'metric' as const,
  }));

export const shapeDrawCircleParamsSelector = createStateSelector([
  shapeDrawStateSelector,
  shapeDrawProximityCircleParamsSelector,
], (shapeDrawState, proximityCircleParams) => {
  const configurationParams = shapeDrawState.configuration === ShapeDrawConfiguration.CreateIndividualProximity
    ? proximityCircleParams
    : DEFAULT_CIRCLE_PARAMETERS;

  return configurationParams;
});
